import englishMessages from '../i18n/en';
import germanMessages from '../i18n/de';

const messages = {
	en: englishMessages,
	de: germanMessages
};

export default locale => messages[locale];
